import { Box } from '@mui/material'
import { useTranslations } from '~/src/hooks/useTranslations'
import { LoginFormInterface } from '~/src/types/forms/LoginFormInterface'
import { FormikProps } from 'formik'
import FormikTextField from '~/src/components/mui-wrappers/fields/FormikTextField'
import { useEoValue } from '~/src/hooks/useEoState'
import { AUTHENTICATION_FLOW_STATE, AuthenticationFlowState } from '~/src/stores/authentication-flow'
import PhoneInput from '~/src/components/mui-wrappers/styled/phone-input'

interface Props {
  form: FormikProps<LoginFormInterface>,
  fieldsColor: 'container' | 'content',
}

const LoginFormFields = ({ form, fieldsColor = 'content' }: Props) => {
  const { customer } = useEoValue<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const { t } = useTranslations()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4
      }}
    >
      {!!customer?.email && (
        <FormikTextField
          TextFieldProps={{
            form,
            color: fieldsColor,
            name: 'email',
            inputMode: 'email',
            label: t('auth.whatsYourEmail'),
            disabled: true,
            InputProps: {
              sx: {
                input: {
                  fontSize: '1.25rem'
                }
              }
            }
          }}
        />
      )}

      {!!customer?.phone && (
        <PhoneInput
          PhoneInputProps={{
            form,
            label: t('auth.phone'),
            color: fieldsColor,
            name: 'phone',
            disabled: true,
            autoFocus: true,
            InputProps: {
              sx: {
                input: {
                  fontSize: '1.25rem'
                }
              }
            }
          }}
        />
      )}

      <FormikTextField
        TextFieldProps={{
          form,
          color: fieldsColor,
          name: 'password',
          type: 'password',
          label: t('auth.password'),
          InputProps: {
            sx: {
              input: {
                fontSize: '1.25rem'
              }
            }
          }
        }}
      />
    </Box>
  )
}

export default LoginFormFields
